import React from 'react';
import { Checkbox, TagGeneral, Text } from '@spark';
import {
    EVALUATION_NORMALIZATION_OPTIONS,
    applyEvaluationNormalizationPreview,
} from '../utils/evaluationNormalization';

/**
 * "When evaluating" section (Figma Model Configuration): output-cleanup flags
 * applied to model outputs before evaluation comparison. Shown under the
 * Compare section on the Commercial tab and at the bottom of the SpecificAI
 * tab (shared state).
 */
const WhenEvaluatingSection = ({
    normalization,
    onChange,
    disabled = false,
    evaluatedSample = null,
    labelNames = null,
}) => {
    const evaluatedPreview =
        typeof evaluatedSample === 'string' && evaluatedSample.trim()
            ? applyEvaluationNormalizationPreview(evaluatedSample, normalization, labelNames)
            : null;

    return (
        <div className="model-setup-when-evaluating fs-unmask">
            <Text variant="base-medium" color="primary" as="div">
                When evaluating
            </Text>
            <Text variant="detail-regular" color="secondary" as="div">
                Clean model outputs before evaluation to improve match accuracy.
            </Text>
            {EVALUATION_NORMALIZATION_OPTIONS.map(({ key, label, help }) => (
                <div key={key} className="model-setup-when-evaluating__row">
                    <Checkbox
                        label={label}
                        status={normalization?.[key] ? 'active' : 'inactive'}
                        disabled={disabled}
                        onChange={() => {
                            if (disabled) return;
                            onChange?.({ [key]: !normalization?.[key] });
                        }}
                    />
                    <Text
                        variant="detail-regular"
                        color="secondary"
                        as="div"
                        className="model-setup-when-evaluating__help"
                    >
                        {help}
                    </Text>
                </div>
            ))}
            {evaluatedPreview != null && (
                <div className="model-setup-when-evaluating__preview">
                    <Text variant="base-regular" color="secondary" as="span">
                        Evaluated as
                    </Text>
                    <TagGeneral label={evaluatedPreview} className="model-setup-when-evaluating__preview-tag" />
                </div>
            )}
        </div>
    );
};

export default WhenEvaluatingSection;
